import {gsap} from "gsap";
import {IFsSymbolData} from "../FreespinSymbol";
import {BitmapText} from "pixi.js";
import Spine = PIXI.spine.Spine;
import {FITH2FontConfig} from "../../../configs/FITH2FontConfig";
import {FireInTheHole2} from "../../../FireInTheHole2";
import {FITH2Helper} from "../../../utils/FITH2Helper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {FITH2SoundManager} from "../../../sound/FITH2SoundManager";

export class FreespinTrainSymbol extends PIXI.Container {
    protected _name: string;
    protected _value: number;
    protected _hasTriggered: boolean;
    protected _reelId: number = -1;
    protected _valueText: BitmapText;
    protected _spine: Spine | null;

    public createCoin(): void {
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset(this._reelId === 6 ? "upgrade" : "wagon"));
        this.addChild(this._spine);
    }

    public trigger(): gsap.core.Timeline {
        if (this._hasTriggered) {
            return gsap.timeline();
        }
        this._hasTriggered = true;
        const feature: string = "_" + FITH2Helper.removeNumbersInString(this._name);
        const tl = gsap.timeline();
        tl.add([
            () => {
                if (this._name[0] === "C") {
                    FITH2SoundManager.playSound("fsMultiDownToCoin");
                } else if (feature === "DY") {
                    FITH2SoundManager.playSound("fsDynamiteWagonHighlight");
                }
            },
            new SpineTween(this._spine!, 0, `trigger${feature}`)
        ]);
        tl.add(this.darkDown());
        return tl;
    }

    public upgrade(): gsap.core.Timeline {
        const tl = gsap.timeline();
        if(this._name === "H"){
            tl.add([
                () => {
                    //FITH2SoundManager.playSound("fsDynamiteWagonHighlight");
                },
                new SpineTween(this._spine!, 1, `trigger`)
            ]);
        }
        return tl;
    }

    public spin(delay: number = 0): gsap.core.Timeline {
        this._hasTriggered = false;
        return gsap.timeline().add(() => {
            this._spine!.state.setAnimation(0, "out", true);
        });
    }

    public darkDown(): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this._spine!.state.setAnimation(0, "darken", true);
        });
    }

    public reset(): void {
        this.value = 0;
    }

    public init(symbolData: IFsSymbolData): void {
    }

    constructor(symbolData: IFsSymbolData) {
        super();
        this.name = `fs${symbolData.reelId}${symbolData.id}`;
        this._name = symbolData.symName;
        this._reelId = symbolData.reelId!;
        this._value = 0;
        this._hasTriggered = false;
        this.createCoin();

        this._valueText = new BitmapText("", FITH2FontConfig.FS_COIN_MULTI);
        this._valueText.position.set(0, 0);
        this._valueText.anchor = new PIXI.Point(0.5, 0.5);
    }

    public show(symbolData: IFsSymbolData): void {
        this._name = symbolData.symName;
        let skinName: string = symbolData.symName;
        this._spine!.name = skinName;
        this._spine!.skeleton.setSkinByName(skinName);
        this._spine!.state.setAnimation(0, "base", false);
    }

    public stop(symbolData: IFsSymbolData, fromInit: boolean = false): gsap.core.Timeline {
        this._name = symbolData.symName;
        let skinName: string = symbolData.symName;
        this._spine!.name = skinName;
        this._spine!.skeleton.setSkinByName(skinName);
        this._spine!.state.setAnimation(0, "in", true);
        return gsap.timeline();
    }

    public stopped(isSideTrain: boolean = false): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this._spine!.state.setAnimation(0, "base", false);
        });
        if (isSideTrain) {
            return tl;
        }
        if (this._name === "DC" && (FireInTheHole2.model.reels[this._reelId].indexOf("H") > -1 || FireInTheHole2.model.reels[this._reelId].indexOf("M") > -1)) {
            tl.add(FireInTheHole2.freespinReelArea.playDwarfAnticipation(this._reelId), 0);
        }

        return tl;
    }

    public remove(): FreespinTrainSymbol {
        if (this.parent) {
            this.parent.removeChild(this);
        }

        this.destroy({children: true});
        return this;
    }

    public set value(value: number) {
        if (this._reelId === 6) {
            this._valueText.visible = false;
            return;
        }
        this._value = value;
        this._valueText.text = `${value}x`;
        this._valueText.visible = value > 0;
        this._valueText.scale.set(Math.min(100 / this._valueText.width, 1));
    }
}